export default {
  en: {
    panel: 'Panel',
    subPanel: 'SubPanel'
  },
  fr: {
    panel: 'Panneau',
    subPanel: 'Sous-Panneau'
  }
};